import { AemResponsiveImageBreakpoint } from './useAemResponsiveImageSource';

const BLUE_LABEL_IMAGE_BREAKPOINTS: ReadonlyArray<AemResponsiveImageBreakpoint> = [
    { imageSize: 's', maxViewportWidth: 480 },
    { imageSize: 'l', maxViewportWidth: 720 },
    { imageSize: 'xxl', maxViewportWidth: Number.POSITIVE_INFINITY },
];

const IMAGE_BREAKPOINTS_BY_BRAND: Record<string, ReadonlyArray<AemResponsiveImageBreakpoint>> = {
    audi: [
        { imageSize: 'm', maxViewportWidth: 480 },
        { imageSize: 'l', maxViewportWidth: 720 },
        { imageSize: 'xxl', maxViewportWidth: Number.POSITIVE_INFINITY },
    ],
    cupra: [
        { imageSize: 'm', maxViewportWidth: 720 },
        { imageSize: 'xxl', maxViewportWidth: Number.POSITIVE_INFINITY },
    ],
    seat: [
        { imageSize: 'xs', maxViewportWidth: 350 },
        { imageSize: 's', maxViewportWidth: 520 },
        { imageSize: 'm', maxViewportWidth: 768 },
        { imageSize: 'l', maxViewportWidth: 854 },
        { imageSize: 'xl', maxViewportWidth: 1067 },
        { imageSize: 'xxl', maxViewportWidth: Number.POSITIVE_INFINITY },
    ],
    skoda: [
        { imageSize: 'm', maxViewportWidth: 480 },
        { imageSize: 'l', maxViewportWidth: 720 },
        { imageSize: 'xxl', maxViewportWidth: Number.POSITIVE_INFINITY },
    ],
    vw: [
        { imageSize: 'm', maxViewportWidth: 480 },
        { imageSize: 'l', maxViewportWidth: 720 },
        { imageSize: 'xxl', maxViewportWidth: Number.POSITIVE_INFINITY },
    ],
    vwfs: BLUE_LABEL_IMAGE_BREAKPOINTS,
};

export const getTeaserImageBreakpoints = (brand: string): ReadonlyArray<AemResponsiveImageBreakpoint> =>
    IMAGE_BREAKPOINTS_BY_BRAND[brand] ?? BLUE_LABEL_IMAGE_BREAKPOINTS;
